import styled from 'styled-components'
import measures from 'globals/measures'

interface OverlayWrapperProps {
  visible: boolean
}

export const OverlayWrapper = styled.div<OverlayWrapperProps>`
  width: 100%;
  height: 0;
  background: rgba(40, 44, 46, 0.5);
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  
  transition: height 0ms 300ms, opacity 300ms;
  
  @media (max-width: ${measures.tabletThreshold}px) and (min-width: ${measures.mobileThreshold}px) {
    ${(props) => props.visible && `
      height: 100%;
      opacity: 1;
      
      transition: height 0ms, opacity 300ms;
    `};
  }
`
